<div class="info-container">
  <!-- === DETAILS TAB === -->
  <ng-container *ngIf="visibleTab === 'details'">
    <!-- Company info -->
    <div class="det-section-header">
      <span class="det-section-title">{{ "companies.company_details" | translate }}</span>
    </div>
    <div class="det-row">
      <span class="det-label">{{ "common.name" | translate }}</span>
      <span class="det-value">{{ customer?.name || '--' }}</span>
    </div>
    <div class="det-row" *ngIf="traditionalContactsEnabled">
      <span class="det-label">{{ "common.email" | translate }}</span>
      <a *ngIf="getMainContact()?.email as email" class="det-value det-link" [href]="'mailto:' + email">{{ email }}</a>
      <span *ngIf="!getMainContact()?.email" class="det-value">--</span>
    </div>
    <div class="det-row" *ngIf="traditionalContactsEnabled">
      <span class="det-label">{{ "common.phone" | translate }}</span>
      <span class="det-value">{{ getMainContact()?.phone || '--' }}</span>
    </div>
    <div class="det-row">
      <span class="det-label">{{ 'customers.details.website' | translate }}</span>
      <span class="det-value">--</span>
    </div>
    <div class="det-row det-row-top">
      <span class="det-label">{{ 'customers.details.main_location' | translate }}</span>
      <div class="det-tag-col" *ngIf="getMainLocation() as mainLoc; else noMainLoc">
        <div class="det-location-tag">
          <mat-icon class="det-tag-icon">place</mat-icon>
          <span>{{ mainLoc.name }}</span>
        </div>
        <span class="det-tag-sub">{{ formatShippingAddress(mainLoc) }}</span>
      </div>
      <ng-template #noMainLoc><span class="det-value">--</span></ng-template>
    </div>
    <div class="det-row" *ngIf="traditionalContactsEnabled">
      <span class="det-label">{{ 'customers.details.main_contact_label' | translate }}</span>
      <div class="det-contact-tag" *ngIf="getMainContact() as mc; else noMainContact">
        <mat-icon class="det-tag-icon">person_outline</mat-icon>
        <span>{{ mc.contact_fname }} {{ mc.contact_lname }}</span>
      </div>
      <ng-template #noMainContact><span class="det-value">--</span></ng-template>
    </div>

    <div class="det-divider"></div>

    <!-- Shipping -->
    <div class="det-section-header">
      <span class="det-section-title">{{ 'companies.shipping' | translate }}</span>
    </div>
    <div class="det-row det-row-top">
      <span class="det-label">{{ 'customers.details.default_shipping_address' | translate }}</span>
      <div class="det-tag-col" *ngIf="currentLocation">
        <div class="det-location-tag">
          <mat-icon class="det-tag-icon">place</mat-icon>
          <span>{{ currentLocation.name }}</span>
        </div>
        <span class="det-tag-sub">{{ formatShippingAddress(currentLocation) }}</span>
      </div>
    </div>
    <!-- One tag per code: a location carries several types, and a type several values. -->
    <div class="det-row det-row-top">
      <span class="det-label">{{ 'companies.tax_codes' | translate }}</span>
      <div class="det-tag-col" *ngIf="taxCodeTags.length; else noTaxCodes">
        <div class="det-tax-tag" *ngFor="let code of taxCodeTags">
          <span class="det-tax-type-badge">{{ code.type }}</span>
          <span class="det-tax-value">{{ code.value }}</span>
        </div>
      </div>
      <ng-template #noTaxCodes>
        <span class="det-value">--</span>
      </ng-template>
    </div>

    <div class="det-divider"></div>

    <!-- Conditions -->
    <div class="det-section-header">
      <span class="det-section-title">{{ 'companies.conditions' | translate }}</span>
    </div>
    <div class="det-row det-row-top">
      <span class="det-label">{{ 'customers.details.default_payment_terms' | translate }}</span>
      <span class="det-value">{{ currentLocation?.payment_terms ? getPaymentTermName(currentLocation!.payment_terms!.id) : '--' }}</span>
    </div>
    <div class="det-row det-row-top">
      <span class="det-label">{{ 'customers.details.default_currency' | translate }}</span>
      <span class="det-value">{{ currentLocation?.currency ? getCurrencyName(currentLocation!.currency!.id) : '--' }}</span>
    </div>
    <div class="det-row det-row-top">
      <span class="det-label">{{ 'customers.details.default_billing_address' | translate }}</span>
      <div class="det-tag-col" *ngIf="currentLocation && !currentLocation.is_bill_same">
        <div class="det-location-tag">
          <mat-icon class="det-tag-icon">place</mat-icon>
          <span>{{ currentLocation.name }}</span>
        </div>
        <span class="det-tag-sub">{{ formatBillingAddress(currentLocation) }}</span>
      </div>
      <span class="det-value" *ngIf="currentLocation?.is_bill_same">{{ 'customers.details.same_as_shipping' | translate }}</span>
    </div>
    <div class="det-row det-row-top">
      <span class="det-label">{{ 'customers.details.custom_discounts' | translate }}</span>
      <div class="det-tag-col">
        <span class="det-value">{{ currentLocation?.custom_discount ? ('common.yes' | translate) : ('common.no' | translate) }}</span>
        <span class="det-tag-sub" *ngIf="currentLocation?.custom_discount">
          {{ 'customers.details.manage_discounts_on_the' | translate }} <span class="det-underline">{{ 'customers.details.preferences_tab' | translate }}</span>
        </span>
      </div>
    </div>

    <div class="det-divider"></div>

    <!-- Internal Notes -->
    <p class="det-section-title">
      {{ 'customers.details.internal_notes' | translate }} <span class="det-optional">({{ 'common.optional' | translate }})</span>
    </p>
    <div class="det-notes-textarea">
      <textarea [placeholder]="'customers.details.internal_notes_placeholder' | translate"></textarea>
    </div>

    <div class="det-divider"></div>

    <!-- Volta-sourced: full provenance -->
    <ng-container *ngIf="currentLocation?.provenance?.source === 'volta'">
      <div class="det-row">
        <span class="det-label">{{ 'customers.details.volta_id' | translate }}</span>
        <span class="det-value">{{ customer?.company_id || '--' }}</span>
      </div>
      <div class="det-row">
        <span class="det-label">{{ 'customers.details.source' | translate }}</span>
        <span
          class="volta-location-icon"
          [matTooltip]="'customers.contacts_tab.volta_location_tooltip' | translate"
          matTooltipClass="product-status-tooltip volta-location-tooltip"
          matTooltipPosition="above"
        >
          <img src="assets/icones/volta_smal_icon.svg" alt="Volta" width="14" height="14">
        </span>
      </div>
      <div class="det-row" *ngIf="currentLocation.provenance?.created_by">
        <span class="det-label">{{ 'customers.details.created_by' | translate }}</span>
        <span class="det-value">{{ currentLocation.provenance?.created_by?.name }}</span>
      </div>
      <div class="det-row" *ngIf="currentLocation.provenance?.created_at">
        <span class="det-label">{{ 'companies.creation_date' | translate }}</span>
        <span class="det-value">{{ currentLocation.provenance?.created_at | date:'mediumDate' }}</span>
      </div>
      <div class="det-row" *ngIf="currentLocation.provenance?.updated_by">
        <span class="det-label">{{ 'customers.details.last_update_by' | translate }}</span>
        <span class="det-value">{{ currentLocation.provenance?.updated_by?.name }}</span>
      </div>
      <div class="det-row" *ngIf="currentLocation.provenance?.updated_at">
        <span class="det-label">{{ 'customers.details.last_update' | translate }}</span>
        <span class="det-value">{{ currentLocation.provenance?.updated_at | date:'mediumDate' }}</span>
      </div>
      <div class="det-row" *ngIf="currentLocation.provenance?.created_from_order_id">
        <span class="det-label">{{ 'customers.details.from_order' | translate }}</span>
        <a class="det-order-link" [routerLink]="['/quotations', currentLocation.provenance?.created_from_order_id]">
          {{ currentLocation.provenance?.created_from_order_name || ('#' + currentLocation.provenance?.created_from_order_id) }}
        </a>
      </div>
    </ng-container>

    <!-- ERP-sourced: minimal (source + last sync) -->
    <ng-container *ngIf="!currentLocation?.provenance || currentLocation?.provenance?.source === 'erp'">
      <div class="det-row">
        <span class="det-label">{{ 'customers.details.source' | translate }}</span>
        <span class="det-value">ERP</span>
      </div>
      <div class="det-row">
        <span class="det-label">{{ 'customers.details.erp_id' | translate }}</span>
        <span class="det-value">{{ customer?.erp_id || '--' }}</span>
      </div>
      <div class="det-row" *ngIf="currentLocation?.provenance?.updated_at">
        <span class="det-label">{{ 'customers.details.last_sync' | translate }}</span>
        <span class="det-value">{{ currentLocation.provenance?.updated_at | date:'mediumDate' }}</span>
      </div>
    </ng-container>

    <div class="det-divider"></div>

    <!-- Custom Fields -->
    <ng-container *ngIf="objectCustomFields?.definitions?.length">
      <div class="det-section-header">
        <span class="det-section-title">{{ "custom_fields.custom_fields" | translate }}</span>
        <button
          class="action-btn secondary-btn icon-btn"
          *appHasPermission="{ module: 'company', action: 'edit' }"
          aria-label="Edit custom fields"
          (click)="editCustomFieldsClicked.emit()"
        >
          <span class="icon"><app-svg-icon svgIcon="pen-cc"></app-svg-icon></span>
        </button>
      </div>
      <app-object-custom-fields-view
        [objectCustomFields]="objectCustomFields"
        [currentLanguage]="currentLanguage"
      ></app-object-custom-fields-view>
    </ng-container>
  </ng-container>

  <!-- === CONTACT TAB === -->
  <ng-container *ngIf="visibleTab === 'contact'">
    <!-- Traditional contact list + main-contact info: hidden when traditionalContactsEnabled is off (WB-7368). Extra emails below is unconditional. -->
    <ng-container *ngIf="traditionalContactsEnabled">
      <!-- Contact Header -->
      <div class="contact-tab-header">
        <div class="contact-tab-title">
          <mat-icon class="contact-tab-icon">person_outline</mat-icon>
          <span>{{ totalContactsCount }} {{ "companies.contacts" | translate }}</span>
        </div>
        <button class="action-btn secondary-btn contact-add-btn"
          *appHasPermission="{ module: 'company', action: 'edit' }"
          (click)="addContactClicked.emit(undefined)">
          <span class="icon"><app-svg-icon svgIcon="plus-cc"></app-svg-icon></span>
          <span class="contact-add-label">{{ "companies.contacts" | translate | uppercase }}</span>
        </button>
      </div>

      <!-- Location-grouped contacts list + popup overlay -->
      <div class="contact-tab-body">
        <!-- Search -->
        <div class="cl-search">
          <mat-icon class="cl-search-icon">search</mat-icon>
          <input #clSearchInput
                 class="cl-search-input"
                 type="text"
                 [placeholder]="'customers.contacts_tab.search_placeholder' | translate"
                 (input)="setContactSearch(clSearchInput.value)">
        </div>

        <!-- Grouped list -->
        <div class="cl-list">
          <div class="cl-location-item"
               *ngFor="let group of filteredContactsGroups; trackBy: trackByLocationId">
            <div class="cl-location-row"
                 (click)="toggleGroup(group.location.id ?? group.location.name)">
              <mat-icon class="cl-chevron" [class.open]="isGroupOpen(group)">chevron_right</mat-icon>
              <div class="cl-loc-icon">
                <mat-icon>business</mat-icon>
              </div>
              <div class="cl-loc-info">
                <span class="cl-loc-name" [matTooltip]="group.location.name">{{ group.location.name }}</span>
              </div>
              <span class="cl-count-badge">{{ group.contacts.length }}</span>
              <span class="cl-main-loc-badge" *ngIf="group.location.is_main">{{ 'customers.main' | translate }}</span>
              <span
                *ngIf="group.location.provenance?.source === 'volta'"
                class="volta-location-icon"
                [matTooltip]="'customers.contacts_tab.volta_location_tooltip' | translate"
                matTooltipClass="product-status-tooltip volta-location-tooltip"
                matTooltipPosition="above"
              >
                <img src="assets/icones/volta_smal_icon.svg" alt="Volta" width="14" height="14">
              </span>
            </div>

            <div class="cl-contacts-list" [class.open]="isGroupOpen(group)">
              <ng-container *ngIf="group.contacts.length > 0; else noContactsForLoc">
                <div class="cl-contact-row"
                     *ngFor="let contact of group.contacts; trackBy: trackByContactId"
                     (click)="addContactClicked.emit(contact)">
                  <div class="cl-avatar" [class.is-main]="contact.is_user">
                    {{ getInitials(contact) }}
                  </div>
                  <div class="cl-contact-info">
                    <div class="cl-contact-name">{{ contact.contact_fname }} {{ contact.contact_lname }}</div>
                    <div class="cl-contact-email">{{ contact.email }}</div>
                  </div>
                  <span class="cl-contact-main-badge" *ngIf="contact.is_user">{{ 'customers.contacts_tab.main_badge' | translate }}</span>
                </div>
              </ng-container>
              <ng-template #noContactsForLoc>
                <div class="cl-no-contacts">{{ "companies.no_contacts" | translate }}</div>
              </ng-template>
            </div>
          </div>

          <div class="cl-empty-search"
               *ngIf="filteredContactsGroups.length === 0 && contactSearchQuery">
            {{ 'customers.contacts_tab.no_results_for' | translate }} "{{ contactSearchQuery }}"
          </div>
        </div>

      </div>
    </ng-container>

    <!-- === EXTRA EMAILS SECTION (merged: company + all locations) === -->
    <div class="extra-emails-section">
      <div class="extra-emails-header">
        <span class="extra-emails-title">{{ 'customers.contacts_tab.extra_emails_title' | translate }}</span>
        <mat-icon class="extra-emails-info-icon"
                  [matTooltip]="'customers.contacts_tab.extra_emails_tooltip' | translate"
                  matTooltipPosition="above">
          info_outline
        </mat-icon>
      </div>
      <p class="extra-emails-description">
        {{ 'customers.contacts_tab.extra_emails_description' | translate }}
      </p>

      <!-- Filter row: scope dropdown (all / company-only / a specific location) + segmented source toggle. -->
      <div class="email-filter-row">
        <button type="button" class="email-scope-btn" [matMenuTriggerFor]="emailScopeMenu">
          <mat-icon>filter_list</mat-icon>
          <span class="email-scope-label">{{ scopeFilterLabel }}</span>
          <mat-icon class="email-scope-caret">arrow_drop_down</mat-icon>
        </button>
        <mat-menu #emailScopeMenu="matMenu">
          <button mat-menu-item [class.active]="scopeFilter === 'all'" (click)="setScopeFilter('all')">
            {{ 'common.all' | translate }}
          </button>
          <button mat-menu-item [class.active]="scopeFilter === 'company'" (click)="setScopeFilter('company')">
            {{ 'customers.contacts_tab.email_scope_company' | translate }}
          </button>
          <button mat-menu-item
                  *ngFor="let loc of allLocations"
                  [class.active]="scopeFilter === loc.id"
                  (click)="setScopeFilter(loc.id!)">
            {{ loc.name }}
          </button>
        </mat-menu>

        <div class="email-filter-group" role="tablist" aria-label="Filter emails by source">
          <button type="button" class="email-filter-btn"
                  role="tab"
                  [class.active]="sourceFilter === 'all'"
                  [attr.aria-selected]="sourceFilter === 'all'"
                  (click)="setSourceFilter('all')">
            {{ 'common.all' | translate }} <span class="email-filter-count">{{ isLoadingEmails ? '…' : totalEmailsCount }}</span>
          </button>
          <button type="button" class="email-filter-btn"
                  role="tab"
                  [class.active]="sourceFilter === 'erp'"
                  [attr.aria-selected]="sourceFilter === 'erp'"
                  (click)="setSourceFilter('erp')">
            {{ 'customers.contacts_tab.email_filter_erp' | translate }} <span class="email-filter-count">{{ isLoadingEmails ? '…' : erpEmailsCount }}</span>
          </button>
          <button type="button" class="email-filter-btn"
                  role="tab"
                  [class.active]="sourceFilter === 'volta'"
                  [attr.aria-selected]="sourceFilter === 'volta'"
                  (click)="setSourceFilter('volta')">
            {{ 'customers.contacts_tab.email_filter_volta' | translate }} <span class="email-filter-count">{{ isLoadingEmails ? '…' : voltaEmailsCount }}</span>
          </button>
        </div>
      </div>

      <!-- Merged email list. Volta rows: click to inline-edit, hover to reveal delete.
           ERP rows are read-only. Location rows carry a badge with the location name. -->
      <div class="email-list">
        <div class="email-loading-state" *ngIf="isLoadingEmails" role="status" aria-live="polite">
          <mat-spinner diameter="18"></mat-spinner>
          <span>{{ 'customers.contacts_tab.emails_loading' | translate }}</span>
        </div>
        <ng-container *ngIf="!isLoadingEmails && visibleEmails.length > 0; else emptyEmails">
          <ng-container *ngFor="let item of visibleEmails; trackBy: trackEmail">
            <div class="email-row"
                 *ngIf="!(item.source === 'volta' && editingEmailId === item.id && editingEmailKind === item.kind)"
                 [class.editable]="item.source === 'volta'"
                 [class.read-only]="item.source === 'erp'">
              <!-- Clickable area (volta rows only) — kept separate from the actions so a
                   delete click can never reach the edit handler. -->
              <div class="email-row-main"
                   [class.clickable]="item.source === 'volta'"
                   (click)="startEditEmail(item)">
                <span class="email-row-text">{{ item.email }}</span>
                <span class="email-location-badge"
                      *ngIf="item.kind === 'location'"
                      [matTooltip]="item.locationName || ''">{{ item.locationName }}</span>
                <span class="email-source-tag erp-tag" *ngIf="item.source === 'erp'">
                  {{ 'customers.contacts_tab.email_filter_erp' | translate }}
                </span>
              </div>
              <div class="email-actions"
                   *ngIf="item.source === 'volta' && !(confirmingDeleteEmailId === item.id && confirmingDeleteEmailKind === item.kind)">
                <button class="email-action-btn delete"
                        *appHasPermission="{ module: 'company', action: 'edit' }"
                        (click)="requestDeleteEmail(item)"
                        [matTooltip]="'common.delete' | translate">
                  <mat-icon>delete_outline</mat-icon>
                </button>
              </div>
              <div class="email-confirm-delete"
                   *ngIf="item.source === 'volta' && confirmingDeleteEmailId === item.id && confirmingDeleteEmailKind === item.kind"
                   (keydown.escape)="cancelDeleteEmail()">
                <span class="email-confirm-delete-prompt">{{ 'customers.contacts_tab.delete_email_confirm' | translate }}</span>
                <button class="email-confirm-delete-btn" (click)="confirmDeleteEmail()">
                  {{ 'customers.contacts_tab.delete_email_confirm_yes' | translate }}
                </button>
                <button class="email-confirm-delete-cancel" (click)="cancelDeleteEmail()">
                  {{ 'common.cancel' | translate }}
                </button>
              </div>
            </div>
            <!-- Inline edit (Volta only) — email text only; the row's company/location assignment is fixed. -->
            <div class="email-inline-form"
                 *ngIf="item.source === 'volta' && editingEmailId === item.id && editingEmailKind === item.kind">
              <input type="email"
                     class="email-inline-input"
                     [(ngModel)]="editingEmailValue"
                     (keydown.enter)="confirmEditEmail()"
                     (keydown.escape)="cancelEditEmail()"
                     [placeholder]="'customers.contacts_tab.enter_email_placeholder' | translate" />
              <button class="email-confirm-btn" (click)="confirmEditEmail()">
                <mat-icon>check</mat-icon>
              </button>
              <button class="email-cancel-btn" (click)="cancelEditEmail()">
                <mat-icon>close</mat-icon>
              </button>
              <span class="email-error" *ngIf="emailError">{{ emailError }}</span>
              <span class="email-error" *ngIf="emailMutationError">{{ emailMutationError.message }}</span>
            </div>
          </ng-container>
        </ng-container>
        <ng-template #emptyEmails>
          <div class="email-empty-state" *ngIf="!isLoadingEmails">{{ emailEmptyMessage }}</div>
        </ng-template>
      </div>

      <!-- Add form: email + optional location. Empty location → company email; a chosen location → that location's email. -->
      <div class="email-add-form" *ngIf="showAddEmailForm">
        <div class="email-add-fields">
          <input type="email"
                 class="email-inline-input"
                 [(ngModel)]="newEmailInput"
                 (keydown.enter)="addManualEmail()"
                 (keydown.escape)="toggleAddEmailForm()"
                 [placeholder]="'customers.contacts_tab.enter_email_placeholder' | translate" />
          <select class="email-location-select" [(ngModel)]="newEmailLocationId">
            <option [ngValue]="null">{{ 'customers.contacts_tab.email_scope_company' | translate }}</option>
            <option *ngFor="let loc of allLocations" [ngValue]="loc.id">{{ locationOptionLabel(loc) }}</option>
          </select>
        </div>
        <div class="email-add-actions">
          <button class="email-confirm-btn" (click)="addManualEmail()">
            <mat-icon>check</mat-icon>
          </button>
          <button class="email-cancel-btn" (click)="toggleAddEmailForm()">
            <mat-icon>close</mat-icon>
          </button>
          <span class="email-error" *ngIf="addEmailError">{{ addEmailError }}</span>
          <span class="email-error" *ngIf="emailMutationError">{{ emailMutationError.message }}</span>
        </div>
      </div>
      <ng-container *appHasPermission="{ module: 'company', action: 'edit' }">
        <button class="email-add-btn" *ngIf="!showAddEmailForm" (click)="toggleAddEmailForm()">
          <mat-icon>add</mat-icon>
          <span>{{ 'customers.contacts_tab.add_email' | translate }}</span>
        </button>
      </ng-container>
    </div>
  </ng-container>
</div>
